<template>
  <div class="identification-log app-panel blank-h blank-v">
    <div class="tabs">
      <p :class="{active: tabsIndex === 1}" @click="switchTab(1)">客户</p>
      <p :class="{active: tabsIndex === 2}" @click="switchTab(2)">集团员工</p>
      <p :class="{active: tabsIndex === 3}" @click="switchTab(3)">外部员工</p>
    </div>
    <identification-log-customer v-if="tabsIndex === 1"></identification-log-customer>
    <identification-log-staff v-else-if="tabsIndex === 2"></identification-log-staff>
    <identification-log-extra-staff v-else></identification-log-extra-staff>
  </div>
</template>

<script>
  import IdentificationLogCustomer from '@/views/IdentificationLogCustomer.vue';
  import IdentificationLogStaff from '@/views/IdentificationLogStaff.vue';
  import IdentificationLogExtraStaff from '@/views/IdentificationLogExtraStaff.vue';

  export default {
    name: 'IdentificationLog',
    data() {
      return {
        tabsIndex: null
      }
    },
    mounted() {
      this.switchTab(1);
    },
    components: {
      IdentificationLogCustomer,
      IdentificationLogStaff,
      IdentificationLogExtraStaff
    },
    methods: {
      switchTab(index) {
        this.tabsIndex = index;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .identification-log {
    margin-top: 42px;
    position: relative;
    &.blank-v {
      padding-bottom: 0;
    }
    .tabs {
      display: flex;
      height: 40px; 
      position: absolute;
      top: -42px;
      left: 0;
      p {
        padding: 0 20px;
        cursor: pointer;
        min-width: 60px;
        height: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 2px solid transparent;
        transition: all @time;
        background-color: rgba(255, 255, 255, .5);
        &.active {
          background-color: rgba(255, 255, 255, 1);
          border-top: 2px solid @color-primary;
        }
      }
    }
  }
</style>